import {IModuleContextState} from './ModuleContext.ts';
import {IModuleState} from '@/types/state';

export type StateDataItem<T extends IModuleState, k extends keyof T = keyof T> = { key: keyof T, value: T[k] }


type ModuleContextActions<T extends IModuleState> =
    | { type: 'setState', payload: StateDataItem<T> }
    | { type: 'cleanState', payload: T }

const ModuleReducer = <T extends IModuleState>(state: IModuleContextState<T>, action: ModuleContextActions<T>): IModuleContextState<T> => {

    switch (action.type) {
    case 'setState':
        return {
            ...state,
            state: {
                ...state.state,
                [action.payload.key]: action.payload.value
            }
        }

    case 'cleanState': {
        return {
            ...state,
            state: action.payload
        }
    }

    default:
        return state
    }
}

export default ModuleReducer
